import { render, staticRenderFns } from "./wasteGoods.vue?vue&type=template&id=56d85968&scoped=true&"
import script from "./wasteGoods.vue?vue&type=script&lang=js&"
export * from "./wasteGoods.vue?vue&type=script&lang=js&"
import style0 from "./wasteGoods.vue?vue&type=style&index=0&id=56d85968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d85968",
  null
  
)

export default component.exports